<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  item: any
}
const props = defineProps<Props>()
const oldWards = computed(() => {
  return props.item.old.map((item: any) => {
    return item.old_ward_name
  })
})
</script>

<template>
  <span class="name">
    <code>{{props.item.id}}</code> - <strong>{{props.item.name}}</strong><br/>
    <span style="color: #ababab">{{oldWards.join(', ')}}</span>
  </span>
</template>

<style scoped>

</style>
